// // // import { width } from '@mui/system';
// // import axios from "axios";
// // import React, { useEffect, useState } from "react";
// // import { Link, NavLink, useHistory } from "react-router-dom";
// // import { FaArrowLeft } from "react-icons/fa";
// // import "../Components/Component-css/Header.css";
// // import css from "./Component-css/Nav.module.css";
// // import { BsPeople } from 'react-icons/bs';
// // import BottonMenu from "../uiComponents/BottonMenu";
// // import { BsWallet, BsGift } from 'react-icons/bs'
// // import { IoMdNotificationsOutline } from "react-icons/io";
// // import { FiPlus } from "react-icons/fi";
// // import "../Components/Component-css/Header.css";
// // import { GiHamburgerMenu } from "react-icons/gi";
// // import { LanguageContext } from "./LanguageContext";
// // import { useContext } from "react";
// // import { useTheme } from "../../ThemeContext";
// // import { apiRequest } from "../../apiService/allApi";
// // import { FaPlus } from "react-icons/fa";
// // import { FaUsers } from "react-icons/fa6";
// // import { useLocation } from "react-router-dom";
// // import { IoMenu } from "react-icons/io5";

// // const w3_close = () => {
// //   const sidebar = document.getElementById("gold_sidebar");
// //   const overlay = document.getElementById("sidebarOverlay");

// //   if (sidebar) {
// //     sidebar.style.left = "-320px";
// //   }

// //   if (overlay) {
// //     overlay.style.display = "none";
// //   }
// // };

// // const w3_open = () => {
// //   const sidebar = document.getElementById("gold_sidebar");
// //   const overlay = document.getElementById("sidebarOverlay");

// //   if (sidebar) {
// //     sidebar.style.left = "0";
// //   }

// //   if (overlay) {
// //     overlay.style.display = "block";
// //   }
// // };

// // const addsetting = localStorage.getItem("sitSetting");

// // const addCaseSetting = JSON.parse(addsetting);
// // const udata = localStorage.getItem("udata");
// // const profileData = JSON.parse(udata);

// // const Header = ({ user }) => {
// //   const location = useLocation();

// //   // BASE URL

// //   const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
// //   const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
// //   const nodeMode = process.env.NODE_ENV;
// //   if (nodeMode === "development") {
// //     var baseUrl = beckendLocalApiUrl;
// //   } else {
// //     baseUrl = beckendLiveApiUrl;
// //   }
// //   // +++++++++++++++++++++++++++++
// //   const [isdropdownVisible, setIsdropdownVisible] = useState(false);

// //   const toggleDiv = () => {
// //     setIsdropdownVisible(!isdropdownVisible);
// //   };

// //   const history = useHistory();

// //   let access_token = localStorage.getItem("token");
// //   access_token = localStorage.getItem("token");

// //   const logout = async () => {
// //     const headers = {
// //       Authorization: `Bearer ${access_token}`,
// //     };

// //     const respone = await apiRequest(`logout`, "POST", null, headers)

// //     localStorage.removeItem("token");
// //     window.location.reload();
// //     history.push("/");

// //   };

// //   const [promptInstall, setPromptInstall] = useState(null);
// //   const [supportsPWA, setSupportsPWA] = useState(false)


// //   useEffect(() => {
// //     const handler = e => {
// //       e.preventDefault();
// //       console.log('beforeinstallprompt event was fired');
// //       setPromptInstall(e);
// //       setSupportsPWA(true)
// //     };

// //     window.addEventListener('beforeinstallprompt', handler);

// //     return () => window.removeEventListener('beforeinstallprompt', handler);
// //   }, []);

// //   const onClick = (evt) => {
// //     evt.preventDefault();
// //     if (!promptInstall) {
// //       console.log('No promptInstall event available');
// //       return;
// //     }
// //     promptInstall.prompt();
// //     promptInstall.userChoice.then((choiceResult) => {
// //       if (choiceResult.outcome === 'accepted') {
// //         console.log('User accepted the install prompt');
// //       } else {
// //         console.log('User dismissed the install prompt');
// //       }
// //       setPromptInstall(null);
// //     });
// //   };

// //   // language
// //   const { changeLanguage } = useContext(LanguageContext);
// //   const translations = {
// //     hi: {
// //       commission: "कमीशन: 5% : रेफरल: सभी खेलों के लिए 3%",
// //       profile: "मेरी प्रोफाइल",
// //       play: "खेले",
// //       wallet: "वॉलेट",
// //       refer: "रेफरल और कमाएँ",
// //       history: "इतिहास",
// //       support: "सहायता",
// //       // app: "ऐप डाउनलोड",
// //       kyc: "केवाईसी"
// //     },
// //     en: {
// //       commission: "COMMISSION: 5% : REFERRAL: 3% FOR ALL GAMES",
// //       profile: "My Profile",
// //       play: "Play",
// //       wallet: "My Wallet",
// //       refer: "Refer and Earn",
// //       history: "History",
// //       support: "Support",
// //       notify: "Notification",
// //       // app: " App ",
// //       kyc: "KYC",
// //     },
// //   };

// //   const { language } = useContext(LanguageContext);

// //   // // change theme
// //   // const { theme, toggleTheme } = useTheme("light");
// //   // const theme1 = localStorage.getItem('theme')

// //   // const styles = {
// //   //   backgroundColor: theme1 === 'light' ? '#000' : 'black',
// //   //   color: theme1 === 'light' ? '#fff' : '#fff',
// //   // };
// //   // const styles1 = {
// //   //   backgroundColor: theme1 === 'light' ? '#fff' : '#6c757d',
// //   //   color: theme1 === 'light' ? 'black !important' : '#fff !important',

// //   // };
// //   // const logo = theme1 === 'light' ? '../images/box-ludo-logo.png' : '../images/box-ludo-logo.png';

// //   // const colorChange = () => {
// //   //   localStorage.setItem("theme", "#fff")
// //   //   toggleTheme('#fff')
// //   // }

// //   // useEffect(() => {
// //   //   localStorage.setItem("theme", "light")

// //   // }, [])

// //   const { theme, toggleTheme } = useTheme();




// //   return (
// //     <>
// //       <div>
// //         {access_token ? (
// //           <React.Fragment>
// //             {/* <div id="sidebarOverlay" onClick={w3_close}></div> */}
// //             <div id="sidebarOverlay" className="gold_sidebar_overlay" onClick={w3_close}></div>

// //             <div className="gold_sidebar_wrapper">

// //               <div
// //                 className="gold_sidebar"
// //                 id="gold_sidebar"
// //               >

// //                 <span className="gold_close_btn" onClick={w3_close}>
// //                   <img src="../close.png" alt="" />
// //                 </span>

// //                 {/* HEADER */}

// //                 <div className="gold_sidebar_header">

// //                   <div className="gold_logo_box">
// //                     {/* <img src="../images/box-ludo-logo.png" className="img-fluid" /> */}
// //                     <img
// //                       src="../images/box-ludo-logo.png"
// //                       className="header_logo"
// //                       alt="logo"
// //                     />

// //                   </div>

// //                 </div>

// //                 {/* PROFILE */}

// //                 <Link
// //                   to={"/Profile"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">

// //                     {user && user?.avatar ? (
// //                       <img
// //                         width="30"
// //                         height="30"
// //                         src={baseUrl + user?.avatar}
// //                         alt="profile"
// //                         style={{ borderRadius: "50%" }}
// //                       />
// //                     ) : (
// //                       <img
// //                         src="images/icons/sidebar-user.png"
// //                         alt="profile"
// //                       />
// //                     )}

// //                   </picture>

// //                   <h3>{translations[language].profile}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 {/* PLAY */}

// //                 <Link
// //                   to={"/Homepage/ludoClassicManual"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/icons/play-button.png"
// //                     />
// //                   </picture>

// //                   <h3>{translations[language].play}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 {/* WALLET */}

// //                 <Link
// //                   to={"/wallet"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/icons/digital-wallet.png"
// //                     />
// //                   </picture>

// //                   <h3>{translations[language].wallet}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 {/* REFERRAL */}

// //                 {addCaseSetting?.isReferral && (
// //                   <Link
// //                     to={"/refer"}
// //                     className="gold_menu_card"
// //                     onClick={w3_close}
// //                   >
// //                     <picture className="gold_menu_icon">
// //                       <img
// //                         alt=""
// //                         src="/images/icons/refer1.png"
// //                       />
// //                     </picture>

// //                     <h3>{translations[language].refer}</h3>

// //                     <img
// //                       className="gold_menu_arrow"
// //                       src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                       alt=""
// //                     />
// //                   </Link>
// //                 )}

// //                 {/* HISTORY */}

// //                 <Link
// //                   to={"/history"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/icons/refresh.png"
// //                     />
// //                   </picture>

// //                   <h3>{translations[language].history}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 <Link
// //                   to="/Profile?kyc=true"
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/kyc.png"
// //                     />
// //                   </picture>

// //                   <h3>KYC Verification</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 {/* SUPPORT */}

// //                 <Link
// //                   to={"/support"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/support.jpg"
// //                     />
// //                   </picture>

// //                   <h3>{translations[language].support}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link>

// //                 {/* NOTIFICATION */}

// //                 {/* <Link
// //                   to={"/Notification"}
// //                   className="gold_menu_card"
// //                   onClick={w3_close}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       alt=""
// //                       src="/images/icons/notification.png"
// //                     />
// //                   </picture>

// //                   <h3>{translations[language].notify}</h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/724/724816.png"
// //                     alt=""
// //                   />
// //                 </Link> */}
// //                 {/* <button
// //                   className="theme_toggle_btn"
// //                   onClick={toggleTheme}
// //                 >
// //                   {theme === "light" ? "🌙" : "☀️"}
// //                 </button> */}
// //                 <div
// //                   className="gold_menu_card"
// //                   onClick={toggleTheme}
// //                   style={{ cursor: "pointer" }}
// //                 >
// //                   <picture className="gold_menu_icon">
// //                     <img
// //                       src={
// //                         theme === "light"
// //                           ? "https://cdn-icons-png.flaticon.com/128/10976/10976127.png"
// //                           : "https://cdn-icons-png.flaticon.com/128/8484/8484254.png"
// //                       }
// //                       alt="theme"
// //                     />
// //                   </picture>

// //                   <h3>
// //                     {theme === "light" ? "Dark Mode" : "Light Mode"}
// //                   </h3>

// //                   <img
// //                     className="gold_menu_arrow"
// //                     src="https://cdn-icons-png.flaticon.com/128/11160/11160807.png"
// //                     alt=""
// //                   />
// //                 </div>

// //                 {supportsPWA && (
// //                   <div
// //                     className="gold_install_card"
// //                     onClick={onClick}
// //                   >
// //                     <div className="gold_install_icon">
// //                       📲
// //                     </div>

// //                     <div className="gold_install_content">
// //                       <h4>Install App</h4>
// //                       <p>Fast access & better experience</p>
// //                     </div>


// //                   </div>
// //                 )}


// //               </div>

// //             </div>


// //             <header className="premium_header">
// //               <div className="premium_header_inner">
// //                 <button
// //                   className="menu_btn"
// //                   onClick={w3_open}
// //                   id="hambergar"
// //                 >
// //                   <IoMenu className="menu_icon" />
// //                 </button>

// //                 <Link to="/">
// //                   {/* <img
// //                     src={logo}
// //                     className="header_logo"
// //                     alt="logo"
// //                   /> */}
// //                   <img
// //                     src="../images/box-ludo-logo.png"
// //                     className="header_logo"
// //                     alt="logo"
// //                   />
// //                 </Link>
// //               </div>

// //               <div className="header_right">

// //                 <NavLink
// //                   exact
// //                   to="/Addcase"
// //                   className="header_stat_box blue_stat_box"
// //                 >
// //                   <div className="stat_icon_wrap">
// //                     <img src="https://cdn-icons-png.flaticon.com/128/12254/12254603.png" alt="" />
// //                   </div>

// //                   <div className="stat_content">
// //                     <h4>{user?.Wallet_balance || 0}</h4>
// //                     <span>Coins</span>
// //                   </div>
// //                 </NavLink>

// //                 <NavLink
// //                   exact
// //                   to="/redeem/refer"
// //                   className="header_stat_box pink_stat_box"
// //                 >
// //                   <div className="stat_icon_wrap">
// //                     <img src="https://cdn-icons-png.flaticon.com/128/10536/10536043.png" alt="" />
// //                   </div>

// //                   <div className="stat_content">
// //                     <h4>
// //                       {user?.referral_wallet?.toFixed(2) || "0.00"}
// //                     </h4>
// //                     <span>Referral </span>
// //                   </div>
// //                 </NavLink>

// //               </div>
// //             </header>
// //           </React.Fragment>
// //         ) : (
// //           <>
// //             {/* <div className="w3-teal " style={styles}>
// //             <div className="w3-container ">
// //               <div className={`${css.headerContainer} justify-content-between`}>
// //                 <Link to="/">
// //                   <picture className={`ml-2 ${css.navLogo} d-flex`}>
// //                     <img
// //                       src="./images/malik-logo.png"
// //                       className="snip-img"
// //                       alt="Malik "
// //                       width="30px"
// //                     />
// //                   </picture>
// //                 </Link>

// //                 <div className={`ml-5`}>
// //                   <Link type="button" className="login-btn" to="/login">
// //                     LOGIN
// //                   </Link>
// //                 </div>
// //               </div>
// //             </div>
// //           </div> */}
// //           </>
// //         )}
// //       </div>
// //       {location.pathname !== "/login" && (
// //         <div className="bottom_menus_main">
// //           <BottonMenu w3_close={w3_close} />
// //         </div>
// //       )}
// //     </>
// //   );
// // };

// // export default Header;


// import React, { useContext, useEffect, useState } from "react";
// import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
// import {
//   FaArrowRight,
//   FaBars,
//   FaCoins,
//   FaGift,
//   FaGamepad,
//   FaHistory,
//   FaHeadset,
//   FaMoon,
//   FaMoneyBillWave,
//   FaShieldAlt,
//   FaSun,
//   FaTimes,
//   FaUser,
//   FaWallet,
//   FaDownload,
// } from "react-icons/fa";
// import { LanguageContext } from "./LanguageContext";
// import BottonMenu from "../uiComponents/BottonMenu";
// import { useTheme } from "../../ThemeContext";
// import { apiRequest } from "../../apiService/allApi";
// import "../Components/Component-css/Header.css";

// const readLocalJSON = (key, fallback = {}) => {
//   try {
//     return JSON.parse(localStorage.getItem(key) || "null") || fallback;
//   } catch {
//     return fallback;
//   }
// };

// const Header = ({ user }) => {
//   const location = useLocation();
//   const history = useHistory();
//   const { language } = useContext(LanguageContext);
//   const { theme, toggleTheme } = useTheme();

//   const [promptInstall, setPromptInstall] = useState(null);
//   const [supportsPWA, setSupportsPWA] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);

//   const siteSettings = readLocalJSON("sitSetting", {});
//   const accessToken = localStorage.getItem("token");
//   const backendUrl = process.env.REACT_APP_BACKEND_LOCAL_API || "";

//   const translations = {
//     hi: {
//       profile: "मेरी प्रोफाइल",
//       play: "खेले",
//       wallet: "वॉलेट",
//       refer: "रेफरल और कमाएँ",
//       history: "इतिहास",
//       support: "सहायता",
//       kyc: "KYC Verification",
//       darkMode: "Dark Mode",
//       lightMode: "Light Mode",
//       install: "Install App",
//     },
//     en: {
//       profile: "My Profile",
//       play: "Play",
//       wallet: "My Wallet",
//       refer: "Refer and Earn",
//       history: "History",
//       support: "Support",
//       kyc: "KYC Verification",
//       darkMode: "Dark Mode",
//       lightMode: "Light Mode",
//       install: "Install App",
//     },
//   };
//   const t = translations[language] || translations.en;

//   const closeSidebar = () => setSidebarOpen(false);
//   const openSidebar = () => setSidebarOpen(true);

//   useEffect(() => {
//     const handleBeforeInstallPrompt = (event) => {
//       event.preventDefault();
//       setPromptInstall(event);
//       setSupportsPWA(true);
//     };

//     const handleAppInstalled = () => {
//       setPromptInstall(null);
//       setSupportsPWA(false);
//     };

//     window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
//     window.addEventListener("appinstalled", handleAppInstalled);

//     return () => {
//       window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
//       window.removeEventListener("appinstalled", handleAppInstalled);
//     };
//   }, []);

//   useEffect(() => {
//     if (location.pathname) closeSidebar();
//   }, [location.pathname]);

//   const onInstallClick = async (event) => {
//     event.preventDefault();
//     if (!promptInstall) return;

//     try {
//       await promptInstall.prompt();
//       await promptInstall.userChoice;
//     } catch (error) {
//       console.error("App installation prompt failed:", error);
//     } finally {
//       setPromptInstall(null);
//       setSupportsPWA(false);
//     }
//   };

//   const logout = async () => {
//     try {
//       const token = localStorage.getItem("token");
//       if (token) {
//         await apiRequest("logout", "POST", null, {
//           Authorization: `Bearer ${token}`,
//         });
//       }
//     } catch (error) {
//       console.error("Logout request failed:", error);
//     } finally {
//       localStorage.removeItem("token");
//       history.push("/");
//       window.location.reload();
//     }
//   };

//   const avatarSrc = user?.avatar
//     ? `${backendUrl}${user.avatar}`
//     : "/images/icons/sidebar-user.png";

//   const sidebarLinks = [
//     {
//       to: "/Profile",
//       label: t.profile,
//       icon: user?.avatar ? null : FaUser,
//       image: user?.avatar ? avatarSrc : null,
//       alt: "Profile",
//     },
//     {
//       to: "/Homepage/ludoClassicManual",
//       label: t.play,
//       icon: FaGamepad,
//     },
//     {
//       to: "/wallet",
//       label: t.wallet,
//       icon: FaWallet,
//     },
//     ...(siteSettings?.isReferral
//       ? [{ to: "/refer", label: t.refer, icon: FaGift }]
//       : []),
//     {
//       to: "/history",
//       label: t.history,
//       icon: FaHistory,
//     },
//     {
//       to: "/Profile?kyc=true",
//       label: t.kyc,
//       icon: FaShieldAlt,
//     },
//     {
//       to: "/support",
//       label: t.support,
//       icon: FaHeadset,
//     },
//   ];

//   return (
//     <>
//       {accessToken && (
//         <>
//           <div
//             id="sidebarOverlay"
//             className={`bx-sidebar-overlay ${sidebarOpen ? "is-open" : ""}`}
//             onClick={closeSidebar}
//             aria-hidden={!sidebarOpen}
//           />

//           <aside
//             className={`bx-sidebar ${sidebarOpen ? "is-open" : ""}`}
//             id="gold_sidebar"
//             aria-hidden={!sidebarOpen}
//           >
//             <div className="bx-sidebar-header">
//               <Link to="/" onClick={closeSidebar} className="bx-sidebar-logo-link">
//                 <img
//                   src="../images/box-ludo-logo.png"
//                   className="bx-sidebar-logo"
//                   alt="Box Ludo"
//                 />
//               </Link>

//               <button
//                 type="button"
//                 className="bx-sidebar-close"
//                 onClick={closeSidebar}
//                 aria-label="Close navigation menu"
//               >
//                 <FaTimes />
//               </button>
//             </div>

//             <div className="bx-sidebar-profile">
//               <img src={avatarSrc} alt="User profile" />
//               <div className="bx-sidebar-profile-copy">
//                 <span className="bx-sidebar-eyebrow">WELCOME BACK</span>
//                 <strong>{user?.name || user?.username || "Box Ludo"}</strong>
//               </div>
//               <span className="bx-profile-status" />
//             </div>

//             <nav className="bx-sidebar-nav" aria-label="Main navigation">
//               {sidebarLinks.map((item) => {
//                 const Icon = item.icon;
//                 return (
//                   <NavLink
//                     key={item.to}
//                     to={item.to}
//                     className="bx-menu-card"
//                     onClick={closeSidebar}
//                   >
//                     <span className="bx-menu-icon">
//                       {item.image ? (
//                         <img src={item.image} alt={item.alt || ""} />
//                       ) : Icon ? (
//                         <Icon />
//                       ) : null}
//                     </span>
//                     <span className="bx-menu-label">{item.label}</span>
//                     <FaArrowRight className="bx-menu-arrow" />
//                   </NavLink>
//                 );
//               })}
//             </nav>

//             <button
//               type="button"
//               className="bx-menu-card bx-theme-toggle"
//               onClick={toggleTheme}
//             >
//               <span className="bx-menu-icon">
//                 {theme === "light" ? <FaMoon /> : <FaSun />}
//               </span>
//               <span className="bx-menu-label">
//                 {theme === "light" ? t.darkMode : t.lightMode}
//               </span>
//               <span className={`bx-theme-switch ${theme === "light" ? "is-light" : ""}`}>
//                 <span />
//               </span>
//             </button>

//             {supportsPWA && (
//               <button
//                 type="button"
//                 className="bx-sidebar-install"
//                 onClick={onInstallClick}
//               >
//                 <span className="bx-install-icon"><FaDownload /></span>
//                 <span className="bx-install-copy">
//                   <strong>{t.install}</strong>
//                   <small>Fast access & better experience</small>
//                 </span>
//                 <FaArrowRight className="bx-install-arrow" />
//                 <span className="bx-install-shine" />
//               </button>
//             )}
//           </aside>

//           <header className="bx-premium-header">
//             <div className="bx-header-inner">
//               <div className="bx-header-brand">
//                 <button
//                   type="button"
//                   className="bx-header-menu"
//                   onClick={openSidebar}
//                   aria-label="Open navigation menu"
//                   aria-expanded={sidebarOpen}
//                 >
//                   <FaBars />
//                   <span className="bx-header-button-glow" />
//                 </button>

//                 <Link to="/" className="bx-header-logo-link" aria-label="Box Ludo home">
//                   <img
//                     src="../images/box-ludo-logo.png"
//                     className="bx-header-logo"
//                     alt="Box Ludo"
//                   />
//                 </Link>
//               </div>

//               <div className="bx-header-stats">
//                 <NavLink exact to="/Addcase" className="bx-header-stat bx-coins-stat">
//                   <div className="bx-stat-icon" aria-hidden="true">
//                     <span className="bx-stat-ring bx-ring-one" />
//                     <span className="bx-stat-ring bx-ring-two" />
//                     <FaCoins className="bx-stat-main-icon" />
//                   </div>
//                   <div className="bx-stat-info">
//                     <span className="bx-stat-label">COINS</span>
//                     <strong className="bx-stat-value">{user?.Wallet_balance || 0}</strong>
//                     {/* <span className="bx-stat-caption">Available Balance</span> */}
//                   </div>
//                   <span className="bx-stat-arrow" aria-hidden="true"><FaArrowRight /></span>
//                 </NavLink>

//                 <NavLink exact to="/redeem/refer" className="bx-header-stat bx-referral-stat">
//                   <div className="bx-stat-icon" aria-hidden="true">
//                     <span className="bx-stat-ring bx-ring-one" />
//                     <span className="bx-stat-ring bx-ring-two" />
//                     <FaMoneyBillWave className="bx-stat-main-icon" />
//                   </div>
//                   <div className="bx-stat-info">
//                     <span className="bx-stat-label">REFERRAL</span>
//                     <strong className="bx-stat-value">
//                       {user?.referral_wallet?.toFixed(2) || "0.00"}
//                     </strong>
//                     {/* <span className="bx-stat-caption">Total Earnings</span> */}
//                   </div>
//                   <span className="bx-stat-arrow" aria-hidden="true"><FaArrowRight /></span>
//                 </NavLink>
//               </div>
//             </div>
//           </header>
//         </>
//       )}

//       {location.pathname !== "/login" && (
//         <div className="bottom_menus_main">
//           <BottonMenu w3_close={closeSidebar} />
//         </div>
//       )}
//     </>
//   );
// };

// export default Header;


import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink, useHistory, useLocation } from "react-router-dom";
import {
  FaArrowRight,
  FaBars,
  FaCoins,
  FaGift,
  FaGamepad,
  FaHistory,
  FaHeadset,
  FaMoon,
  FaMoneyBillWave,
  FaShieldAlt,
  FaSun,
  FaTimes,
  FaUser,
  FaWallet,
  FaDownload,
} from "react-icons/fa";
import { LanguageContext } from "./LanguageContext";
import BottonMenu from "../uiComponents/BottonMenu";
import { useTheme } from "../../ThemeContext";
import { apiRequest } from "../../apiService/allApi";
import "../Components/Component-css/Header.css";
import "../css/BoxLudoSidebar.css";


const readLocalJSON = (key, fallback = {}) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "null") || fallback;
  } catch {
    return fallback;
  }
};

const Header = ({ user }) => {
  const location = useLocation();
  const history = useHistory();
  const { language } = useContext(LanguageContext);
  const { theme, toggleTheme } = useTheme();

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const siteSettings = readLocalJSON("sitSetting", {});
  const accessToken = localStorage.getItem("token");
  const backendUrl = process.env.REACT_APP_BACKEND_LOCAL_API || "";

  const translations = {
    hi: {
      profile: "मेरी प्रोफाइल",
      play: "खेले",
      wallet: "वॉलेट",
      refer: "रेफरल और कमाएँ",
      history: "इतिहास",
      support: "सहायता",
      kyc: "KYC Verification",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      install: "Install App",
    },
    en: {
      profile: "My Profile",
      play: "Play",
      wallet: "My Wallet",
      refer: "Refer and Earn",
      history: "History",
      support: "Support",
      kyc: "KYC Verification",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      install: "Install App",
    },
  };
  const t = translations[language] || translations.en;

  const closeSidebar = () => setSidebarOpen(false);
  const openSidebar = () => setSidebarOpen(true);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setPromptInstall(event);
      setSupportsPWA(true);
    };

    const handleAppInstalled = () => {
      setPromptInstall(null);
      setSupportsPWA(false);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  useEffect(() => {
    if (location.pathname) closeSidebar();
  }, [location.pathname]);

  const onInstallClick = async (event) => {
    event.preventDefault();
    if (!promptInstall) return;

    try {
      await promptInstall.prompt();
      await promptInstall.userChoice;
    } catch (error) {
      console.error("App installation prompt failed:", error);
    } finally {
      setPromptInstall(null);
      setSupportsPWA(false);
    }
  };

  const logout = async () => {
    try {
      const token = localStorage.getItem("token");
      if (token) {
        await apiRequest("logout", "POST", null, {
          Authorization: `Bearer ${token}`,
        });
      }
    } catch (error) {
      console.error("Logout request failed:", error);
    } finally {
      localStorage.removeItem("token");
      history.push("/");
      window.location.reload();
    }
  };

  const avatarSrc = user?.avatar
    ? `${backendUrl}${user.avatar}`
    : "/images/icons/sidebar-user.png";

  const sidebarLinks = [
    {
      to: "/Profile",
      label: t.profile,
      image: "/images/avatars/profile.png",

      alt: "Profile",
      menuClass: "bx-menu-profile",
      description: "Your account",
    },
    {
      to: "/Homepage/ludoClassicManual",
      label: t.play,
      image: "/images/play.png",
      menuClass: "bx-menu-play",
      description: "Start playing & win rewards",
    },
    {
      to: "/wallet",
      label: t.wallet,
      image: "/images/wallet.png",
      menuClass: "bx-menu-wallet",
      description: "Manage your coins",
    },
    ...(siteSettings?.isReferral
      ? [
        {
          to: "/refer",
          label: t.refer,
          image: "/images/refer-icon.png",

          menuClass: "bx-menu-refer",
          description: "Invite friends & earn",
        },
      ]
      : []),
    {
      to: "/history",
      label: t.history,
      image: "/images/history-icon.png",

      menuClass: "bx-menu-history",
      description: "Your game history",
    },
    {
      to: "/Profile?kyc=true",
      label: t.kyc,
      image: "/images/KYC-icon.png",

      menuClass: "bx-menu-kyc",
      description: "Verify your account",
    },
    {
      to: "/support",
      label: t.support,
      image: "/images/ssupport-icon.png",

      menuClass: "bx-menu-support",
      description: "We're here to help",
    },
  ];

  return (
    <>
      {accessToken && (
        <>
          <div
            id="sidebarOverlay"
            className={`bx-sidebar-overlay ${sidebarOpen ? "is-open" : ""}`}
            onClick={closeSidebar}
            aria-hidden={!sidebarOpen}
          />

          <aside
            className={`bx-sidebar ${sidebarOpen ? "is-open" : ""}`}
            id="gold_sidebar"
            aria-hidden={!sidebarOpen}
          >
            {/* SIDEBAR HEADER */}
            <div className="bx-sidebar-header">
              <Link
                to="/"
                onClick={closeSidebar}
                className="bx-sidebar-logo-link"
              >
                <img
                  src="../images/box-ludo-logo.png"
                  className="bx-sidebar-logo"
                  alt="Box Ludo"
                />
              </Link>

              <button
                type="button"
                className="bx-sidebar-close"
                onClick={closeSidebar}
                aria-label="Close navigation menu"
              >
                <FaTimes />
              </button>
            </div>

            {/* PROFILE CARD */}
            {/* <div className="bx-sidebar-profile">
              <div className="bx-sidebar-avatar-wrap">
                <img
                  src={avatarSrc}
                  alt="User profile"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = "/images/icons/sidebar-user.png";
                  }}
                />
                <span className="bx-profile-status" />
              </div>

              <div className="bx-sidebar-profile-copy">
                <span className="bx-sidebar-eyebrow">WELCOME BACK</span>

                <strong>
                  {user?.name || user?.username || "Box Ludo"}
                </strong>

                <small>Play Smart, Win Big</small>
              </div>
            </div> */}

            {/* NAVIGATION */}
            <nav className="bx-sidebar-nav" aria-label="Main navigation">
              {sidebarLinks.map((item) => {
                const Icon = item.icon;

                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={`bx-menu-card ${item.menuClass || ""}`}
                    activeClassName="bx-menu-active"
                    onClick={closeSidebar}
                    title={item.label}
                  >
                    {/* Decorative background image */}
                    <span className="bx-menu-bg" aria-hidden="true" />

                    {/* Menu icon */}
                    <span className="bx-menu-icon">
                      {item.image ? (
                        <img src={item.image} alt={item.alt || ""} />
                      ) : Icon ? (
                        <Icon />
                      ) : null}
                    </span>

                    {/* Menu title and subtitle */}
                    <span className="bx-menu-copy">
                      <span className="bx-menu-label">{item.label}</span>

                      <small className="bx-menu-description">
                        {item.description || ""}
                      </small>
                    </span>

                    {/* Arrow */}
                    <span className="bx-menu-arrow-wrap" aria-hidden="true">
                      <FaArrowRight className="bx-menu-arrow" />
                    </span>

                    <span className="bx-menu-shine" aria-hidden="true" />
                  </NavLink>
                );
              })}
            </nav>

            {/* THEME TOGGLE */}
            <button
              type="button"
              className="bx-menu-card bx-theme-toggle"
              onClick={toggleTheme}
              aria-label={theme === "light" ? t.darkMode : t.lightMode}
            >
              <span className="bx-menu-bg" aria-hidden="true" />

              <span className="bx-menu-icon">
                {theme === "light" ? <FaMoon /> : <FaSun />}
              </span>

              <span className="bx-menu-copy">
                <span className="bx-menu-label">
                  {theme === "light" ? t.darkMode : t.lightMode}
                </span>

                <small className="bx-menu-description">
                  Change appearance
                </small>
              </span>

              <span
                className={`bx-theme-switch ${theme === "light" ? "is-light" : ""
                  }`}
              >
                <span />
              </span>

              <span className="bx-menu-shine" aria-hidden="true" />
            </button>

            {/* INSTALL APP */}
            {supportsPWA && (
              <button
                type="button"
                className="bx-sidebar-install"
                onClick={onInstallClick}
              >
                <span className="bx-install-icon">
                  <FaDownload />
                </span>

                <span className="bx-install-copy">
                  <strong>{t.install}</strong>
                  <small>Fast access &amp; better experience</small>
                </span>

                <FaArrowRight className="bx-install-arrow" />

                <span className="bx-install-shine" />
              </button>
            )}

            <div className="bx-sidebar-footer">
              <span className="bx-footer-dot" />
              <span>BOX LUDO</span>
              <span className="bx-footer-dot" />
            </div>
          </aside>

          <header className="bx-premium-header">
            <div className="bx-header-inner">
              <div className="bx-header-brand">
                <button
                  type="button"
                  className="bx-header-menu"
                  onClick={openSidebar}
                  aria-label="Open navigation menu"
                  aria-expanded={sidebarOpen}
                >
                  <img src="../images/menu.png" className="img-fluid" />
                  {/* <span className="bx-header-button-glow" /> */}
                </button>

                <Link to="/" className="bx-header-logo-link" aria-label="Box Ludo home">
                  <img
                    src="../images/box-ludo-logo.png"
                    className="bx-header-logo"
                    alt="Box Ludo"
                  />
                </Link>
              </div>

              <div className="bx-header-stats">
                <NavLink exact to="/Addcase" className="bx-header-stat bx-coins-stat">
                  <div className="bx-stat-icon" aria-hidden="true">
                    <span className="bx-stat-ring bx-ring-one" />
                    <span className="bx-stat-ring bx-ring-two" />
                    <FaCoins className="bx-stat-main-icon" />
                  </div>
                  <div className="bx-stat-info">
                    <span className="bx-stat-label">COINS</span>
                    <strong className="bx-stat-value">{user?.Wallet_balance || 0}</strong>
                    {/* <span className="bx-stat-caption">Available Balance</span> */}
                  </div>
                  <span className="bx-stat-arrow" aria-hidden="true"><FaArrowRight /></span>
                </NavLink>

                <NavLink exact to="/redeem/refer" className="bx-header-stat bx-referral-stat">
                  <div className="bx-stat-icon" aria-hidden="true">
                    <span className="bx-stat-ring bx-ring-one" />
                    <span className="bx-stat-ring bx-ring-two" />
                    <FaMoneyBillWave className="bx-stat-main-icon" />
                  </div>
                  <div className="bx-stat-info">
                    <span className="bx-stat-label">REFERRAL</span>
                    <strong className="bx-stat-value">
                      {user?.referral_wallet?.toFixed(2) || "0.00"}
                    </strong>
                    {/* <span className="bx-stat-caption">Total Earnings</span> */}
                  </div>
                  <span className="bx-stat-arrow" aria-hidden="true"><FaArrowRight /></span>
                </NavLink>
              </div>
            </div>
          </header>
        </>
      )}

      {location.pathname !== "/login" && (
        <div className="bottom_menus_main">
          <BottonMenu w3_close={closeSidebar} />
        </div>
      )}
    </>
  );
};

export default Header;
